import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/redux-config/hooks";
import { selectUser } from "@/redux-config/entities/user";
import { Helmet } from "react-helmet";
import { CustomBreadCrumb } from "@/components/customBreadCrumb";
import "./style.scss";
import { selectLanguage } from "@/redux-config/entities/language";
import { Mail, Phone } from "lucide-react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";
import { useTranslation } from "react-i18next";
import { CustomInput, Loading } from "@/components";
import { AdminType } from "@/DTO";
import { AdminApi } from "@/api";
import { ConvertDate } from "@/utils";
import { CustomModal } from "@/components/custom-modal";

const userImage = require("@/assets/image/user-image.png");

export const Info: React.FC<{}> = () => {

  const { t } = useTranslation();

  const crumbs = [
    { name: t("Dashboard"), href: "/" },
    { name: t("Info"), href: "#" }
  ];

  const lang = useAppSelector(selectLanguage);
  const user = useAppSelector(selectUser);
  const [loading, setLoading] = useState<boolean>(true);

  const [data, setData] = useState<AdminType>();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [rePass, setRePass] = useState<string>("");

  const handleGetData = () => {
    setLoading(true);
    AdminApi.GetAdminById(user, user.id).then((data) => {
      setData(data.data);
      setLoading(false);
    }).catch((err) => {

      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const handleChangePassword = () => {
    setLoading(true);
    AdminApi.ChangePasswordAdmin(user, password).then((item) => {
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
    });
  };

  const dataChart = [
    {
      name: "۲/۶",
      product: 4000
    },
    {
      name: "۴/۶",
      product: 3000
    },
    {
      name: "۶/۶",
      product: 2000
    },
    {
      name: "۸/۶",
      product: 2780
    },
    {
      name: "۱۰/۶",
      product: 1890
    },
    {
      name: "۱۲/۶",
      product: 2390
    },
    {
      name: "۱۴/۶",
      product: 3490
    },
    {
      name: "۱۶/۶",
      product: 4300
    },
    {
      name: "۱۸/۶",
      product: 5635
    },
    {
      name: "۲۰/۶",
      product: 4642
    }
  ];

  return (
    <>
      <Helmet>
        <title>MahdiBookShop | User info</title>
        <meta name="description" content="Basic example" />
      </Helmet>
      {loading ? <Loading /> :
        <div className="d-flex flex-column">
          <CustomBreadCrumb breadCrumbList={crumbs} />
          <div className={"d-flex flex-row flex-wrap"}>
            <div className={"col-12 p-2"}>
              <div className={"d-flex flex-column bg-custom-white rounded-3"}>
                <div className={"d-flex flex-column position-relative"}>
                  <img
                    src={"/image/bannar.svg"}
                    className={"w-100 rounded-top-3"}
                    style={{
                      minHeight: "120px",
                      objectFit: "cover",
                      maxHeight: "120px"
                    }}
                  />
                  <div
                    dir={lang == "en" ? "ltr" : "rtl"}
                    className={"bg-custom-white user-image"}
                  >
                    <img src={userImage} width={100} height={100} />
                  </div>
                </div>
                <div
                  className={
                    "d-flex flex-row flex-wrap justify-content-between p-3"
                  }
                >
                  <div className={"d-flex flex-row"}>
                    <div style={{ width: "130px", height: "50px" }}></div>
                    <div className={"d-flex flex-column  mt-2"}>
                      <strong className={"text2"}>{data?.first_name + " " + data?.last_name}</strong>
                    </div>
                  </div>
                  <div className={"d-flex flex-row mt-2 gap-3"}>
                    <div className={"d-flex flex-column text-center"}>
                      <strong className={"text2"}>{t("Role")}</strong>
                      <div className={"text3 d-flex flex-row"}>{data?.role?.map((item, index) => <small
                        key={index}>{item.title}</small>)}</div>
                    </div>
                    <div className={"d-flex flex-column text-center"}>
                      <button onClick={() => {
                        setShowModal(true);
                      }} className={"prm-btn rounded-3"}>{t("ChangePass")}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={"col-12 col-md-6 col-lg-4 p-2 d-flex flex-column gap-3"}
            >
              <div className={"d-flex flex-column bg-custom-white  rounded-3"}>
                <h5 className={"py-3 border-bottom px-3"}>{t("Info")}</h5>
                <div className={"d-flex flex-row px-3 py-2 gap-2"}>
                  <Phone className={"prm3-text col-1"} />
                  <div className={"d-flex flex-column"}>
                    <span className={"text3"}>{t("Phone")}</span>
                    <span className={"text2"}>{data?.phone}</span>
                  </div>
                </div>
                <div className={"d-flex flex-row px-3 py-2 gap-2"}>
                  <Mail className={"prm3-text col-1"} />
                  <div className={"d-flex flex-column"}>
                    <span className={"text3"}>{t("RegisterDate")}</span>
                    <span className={"text2"}>{ConvertDate(data?.created_at + "", lang)}</span>
                  </div>
                </div>
              </div>
              <div data-bs-theme={"dark"} dir={"ltr"}>
                <div
                  className={
                    "d-flex flex-column bg-custom-white p-4 gap-2 gap-lg-3 rounded-4"
                  }
                >
                  <div className={"d-flex flex-row justify-content-end"}>
                    Bank Name
                  </div>
                  <div className={"d-flex flex-row"}>
                    <svg
                      version="1.1"
                      className="chip"
                      id="Layer_1"
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="50px"
                      height="50px"
                      viewBox="0 0 100 100"
                    >
                      <image
                        id="image0"
                        width="100"
                        height="100"
                        x="0"
                        y="0"
                        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
              AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAB6VBMVEUAAACNcTiVeUKVeUOY
              fEaafEeUeUSYfEWZfEaykleyklaXe0SWekSZZjOYfEWYe0WXfUWXe0WcgEicfkiXe0SVekSXekSW
              ekKYe0a9nF67m12ZfUWUeEaXfESVekOdgEmVeUWWekSniU+VeUKVeUOrjFKYfEWliE6WeESZe0GS
              e0WYfES7ml2Xe0WXeESUeEOWfEWcf0eWfESXe0SXfEWYekSVeUKXfEWxklawkVaZfEWWekOUekOW
              ekSYfESZe0eXekWYfEWZe0WZe0eVeUSWeETAnmDCoWLJpmbxy4P1zoXwyoLIpWbjvXjivnjgu3bf
              u3beunWvkFWxkle/nmDivXiWekTnwXvkwHrCoWOuj1SXe0TEo2TDo2PlwHratnKZfEbQrWvPrWua
              fUfbt3PJp2agg0v0zYX0zYSfgkvKp2frxX7mwHrlv3rsxn/yzIPgvHfduXWXe0XuyIDzzISsjVO1
              lVm0lFitjVPzzIPqxX7duna0lVncuHTLqGjvyIHeuXXxyYGZfUayk1iyk1e2lln1zYTEomO2llrb
              tnOafkjFpGSbfkfZtXLhvHfkv3nqxH3mwXujhU3KqWizlFilh06khk2fgkqsjlPHpWXJp2erjVOh
              g0yWe0SliE+XekShhEvAn2D///+gx8TWAAAARnRSTlMACVCTtsRl7Pv7+vxkBab7pZv5+ZlL/UnU
              /f3SJCVe+Fx39naA9/75XSMh0/3SSkia+pil/KRj7Pr662JPkrbP7OLQ0JFOijI1MwAAAAFiS0dE
              orDd34wAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfnAg0IDx2lsiuJAAACLElEQVRIx2Ng
              GAXkAUYmZhZWPICFmYkRVQcbOwenmzse4MbFzc6DpIGXj8PD04sA8PbhF+CFaxEU8iWkAQT8hEVg
              OkTF/InR4eUVICYO1SIhCRMLDAoKDvFDVhUaEhwUFAjjSUlDdMiEhcOEItzdI6OiYxA6YqODIt3d
              I2DcuDBZsBY5eVTr4xMSYcyk5BRUOXkFsBZFJTQnp6alQxgZmVloUkrKYC0qqmji2WE5EEZuWB6a
              lKoKdi35YQUQRkFYPpFaCouKIYzi6EDitJSUlsGY5RWVRGjJLyxNy4ZxqtIqqvOxaVELQwZFZdkI
              JVU1RSiSalAt6rUwUBdWG1CP6pT6gNqwOrgCdQyHNYR5YQFhDXj8MiK1IAeyN6aORiyBjByVTc0F
              qBoKWpqwRCVSgilOaY2OaUPw29qjOzqLvTAchpos47u6EZyYnngUSRwpuTe6D+6qaFQdOPNLRzOM
              1dzhRZyW+CZouHk3dWLXglFcFIflQhj9YWjJGlZcaKAVSvjyPrRQ0oQVKDAQHlYFYUwIm4gqExGm
              BSkutaVQJeomwViTJqPK6OhCy2Q9sQBk8cY0DxjTJw0lAQWK6cOKfgNhpKK7ZMpUeF3jPa28BCET
              amiEqJKM+X1gxvWXpoUjVIVPnwErw71nmpgiqiQGBjNzbgs3j1nus+fMndc+Cwm0T52/oNR9lsdC
              S24ra7Tq1cbWjpXV3sHRCb1idXZ0sGdltXNxRateRwHRAACYHutzk/2I5QAAACV0RVh0ZGF0ZTpj
              cmVhdGUAMjAyMy0wMi0xM1QwODoxNToyOSswMDowMEUnN7UAAAAldEVYdGRhdGU6bW9kaWZ5ADIw
              MjMtMDItMTNUMDg6MTU6MjkrMDA6MDA0eo8JAAAAKHRFWHRkYXRlOnRpbWVzdGFtcAAyMDIzLTAy
              LTEzVDA4OjE1OjI5KzAwOjAwY2+u1gAAAABJRU5ErkJggg=="
                      ></image>
                    </svg>
                  </div>
                  <small className={"text-center"}>
                    IRXX-XXX-XXXXXX-XXX-XXXXXXXXXX
                  </small>
                  <strong>XXXX-XXXX-XXXX-XXXX</strong>
                  <span className={"text-end"}>{data?.first_name + " " + data?.last_name}</span>
                </div>
              </div>
            </div>
            <div
              className={"col-12 col-md-6 col-lg-8 p-2 d-flex flex-column gap-3"}
            >
              <div className={"d-flex flex-column bg-custom-white  rounded-3"}>
                <h5 className={"py-3 border-bottom px-3"}>{t("Statistics")}</h5>
                <div className={"h-100 w-100"} dir={"ltr"}>
                  <ResponsiveContainer width="100%" height={400}>
                    <AreaChart
                      width={800}
                      height={800}
                      data={dataChart}
                      syncId="anyId"
                      margin={{
                        top: 10,
                        right: 30,
                        left: 0,
                        bottom: 0
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Area
                        type="monotone"
                        dataKey="product"
                        stroke="#470178"
                        fill="#c3a0d6"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>
          </div>
          <CustomModal showModal={showModal} setShowModal={setShowModal} title={t("ChangePass") + ""}>
            <div className={"d-flex flex-column gap-3"}>
              <label>
                <span>{t("password")}</span>
                <CustomInput type={"password"} name={"password"}
                             className={`custom-input ${
                               password.length == 0
                                 ? "border-reg"
                                 : password.length >= 8
                                   ? "border-success"
                                   : "border-error"
                             }`}
                             onChange={setPassword} value={password} />
              </label>
              <label>
                <span>{t("rePassword")}</span>
                <CustomInput type={"password"} name={"repassword"}
                             className={`custom-input ${
                               rePass.length == 0
                                 ? "border-reg"
                                 : rePass === password
                                   ? "border-success"
                                   : "border-error"
                             }`}
                             onChange={setRePass} value={rePass} />
              </label>
              <button disabled={!(password.length >= 8 && rePass === password)} onClick={() => {
                handleChangePassword();
                setShowModal(false);
              }}
                      className={"align-self-start prm-btn rounded-3"}>{t("submit")}</button>
            </div>
          </CustomModal>
        </div>
      }
    </>
  );
};
